import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { NavLink } from "react-router-dom";

import img1 from '../images/case-study-thumb1.webp'
import img2 from '../images/case-study-thumb2.webp'
import img3 from '../images/case-study-thumb3.webp'
import img4 from '../images/case-study-client4.webp'
import img5 from '../images/case-study-client5.webp'
import img6 from '../images/case-study-client6.webp'
import img7 from '../images/case-study-client7.webp'
import img8 from '../images/case-study-client8.webp'
import img9 from '../images/case-study-client9.webp'
import img10 from '../images/case-study-client10.webp'
import img11 from '../images/case-study-client11.webp'
import img12 from '../images/case-study-client12.webp'
import img13 from '../images/case-study-client13.webp'
import img14 from '../images/case-study-client14.webp'
import img15 from '../images/case-study-client15.webp'
import img16 from '../images/case-study-client16.webp'
import img17 from '../images/case-study-client17.webp'
import img18 from '../images/case-study-client18.webp'
import img19 from '../images/case-study-client19.webp'
import img20 from '../images/case-study-client20.webp'
import img21 from '../images/case-study-client21.webp'
import img22 from '../images/case-study-client22.webp'
import img23 from '../images/case-study-client23.webp'
import img24 from '../images/case-study-client24.webp'
import img25 from '../images/case-study-client25.webp'
import img26 from '../images/case-study-client26.webp'
import img27 from '../images/case-study-client27.webp'
import img28 from '../images/case-study-client28.webp' 
import img29 from '../images/case-study-client29.webp' 
import img30 from '../images/case-study-client30.webp' 
import img31 from '../images/case-study-client31.webp' 
import img32 from '../images/case-study-client32.webp' 
import img33 from '../images/case-study-client33.webp' 
import img34 from '../images/case-study-client34.webp' 
import img35 from '../images/case-study-client35.webp' 
import img36 from '../images/case-study-client36.webp' 
import img37 from '../images/case-study-client37.webp' 
import img38 from '../images/case-study-client38.webp' 
import img39 from '../images/case-study-client39.webp' 
import img40 from '../images/case-study-client40.webp' 
import img41 from '../images/case-study-client41.webp' 
import img42 from '../images/case-study-client42.webp' 
import img43 from '../images/case-study-client43.webp' 
import img44 from '../images/case-study-client44.webp' 
import img45 from '../images/case-study-client45.webp' 
import img46 from '../images/case-study-client46.webp' 
import img47 from '../images/case-study-client47.webp' 
import img48 from '../images/case-study-client48.webp' 
import img49 from '../images/case-study-client49.webp'
import img50 from '../images/case-study-client50.webp'

import './casestudies.css'

const CaseStudies = ({setBlank}) => {
    // const heading = 'Case Study 1: Fast-tracking';
    // const paragraph = 'The client is a US-based private equity firm with investments in primarily three…';
    // const bttn = 'Find out more about us'
   
    
    // const bttn = 'Read more'

      let creat_url = (str) => {
      str = str.split(/\s+/).join("-");
      str = str.toLowerCase();
      str = "knowledge/" + str;
      return str;
     }
    
     const CaseStudyurl1 = creat_url('Expediting the Investment Process Through a Structured Roadmap');
     const CaseStudyurl2 = creat_url('Enabling A U.S.Based Hedge Fund To Optimize Its Investment Strategy');
     const CaseStudyurl3 = creat_url('Streamlining Business And Facilitating The Implementation Of An ERP System');
     const CaseStudyurl4 = creat_url('Enabling A Real Estate Conglomerate To Secure $40 billion Funding to Develop A Logistics Park');
     const CaseStudyurl5 = creat_url('Strategic Investment Blueprint For A Global Pharma Player');
     const CaseStudyurl6 = creat_url('Cultivating Employee Engagement Insights & Interventions for a Leading Conglomerate');
     const CaseStudyurl7 = creat_url('Corporate Strategy For a Real Estate Development Company');
     const CaseStudyurl8 = creat_url('Strategic Consulting for a PropTech Real Estate Equity Crowdfunding Platform in Kingdom of Saudi Arabia');
     const CaseStudyurl9 = creat_url('Industry Research for an HNI Launching a New Coffee Roastery Brand in the U.S');
     const CaseStudyurl10 = creat_url('Vendor & Counter Party Due Diligence For A Government-Backed Kingdom of Saudi Arabia Entity');
     const CaseStudyurl11 = creat_url('Private Equity Valuation Model for an Investment Firm');
     const CaseStudyurl12 = creat_url('Investment Policy Statement for an Endowment Fund');
     const CaseStudyurl13 = creat_url('Equity Valuation & Fairness Opinion Exercise For A U.S.Based Hedge Fund');
     const CaseStudyurl14 = creat_url('Human Resource Reporting Dashboard For A Company In The Hospitality Industry');
     const CaseStudyurl15 = creat_url('Funding Strategy For A Real Estate Development Subsidiary');     
     const CaseStudyurl16 = creat_url('Enterprise Project Management Office For A Real Estate Development Company');
     const CaseStudyurl17= creat_url('Consolidated Financial Model  for a Kingdom of Saudi Arabia-Based Real Estate Development Project');
     const CaseStudyurl18= creat_url('Investment Memorandum for an Investment Firm');
     const CaseStudyurl19= creat_url('Optimizing Business Processes For A Real Estate Developer');
    //  const CaseStudyurl20 = creat_url('Enabling Sector Understanding Through WACC Benchmarking');
     const CaseStudyurl20 = creat_url('Financial Due Diligence For A U.S.Based Private Equity Firm');
     const CaseStudyurl21 = creat_url('Corporate Strategy For A Single-Family Office');
     const CaseStudyurl22 = creat_url('Customized BI Dashboards for an Investment Corporate');
     const CaseStudyurl23 = creat_url('Periodic Portfolio Performance Review For a U.S.based PE firm');
    //  const CaseStudyurl24 = creat_url('Financial Due Dilligence For a London-based Boutique Private Equity Firm');
     const CaseStudyurl24 = creat_url('Enabling Sector Understanding Through WACC Benchmarking');
     const CaseStudyurl25 = creat_url('Tourism Industry Research For a company operating in the hospitality sector');
     const CaseStudyurl26 = creat_url('Feasibility Study For A Hotel Development By A Real Estate Development Company');
     const CaseStudyurl27 = creat_url('Annual Operating Plan and Budget for a Single Family Office');
     const CaseStudyurl28 = creat_url('Comprehensive Business Plan and a go-to-market strategy for a fintech company');
     const CaseStudyurl29 = creat_url('Optimizing the Development Stage-Gate Process for a Real Estate company');
     const CaseStudyurl30 = creat_url('REIT Market research for a KSA-based real estate fund manager');
     const CaseStudyurl31 = creat_url('Public Equity Screening And Industry Benchmarking for a Saudi based family office');
     const CaseStudyurl32 = creat_url('Joint Venture Proposal for a Infrastructure-Focused Investment fund');
     const CaseStudyurl33 = creat_url('Facilitated IPO planning through comprehensive market analysis and advisor benchmarking');
     const CaseStudyurl34 = creat_url('Master Developer Partnership Proposal for a Master Developer based out of KSA');
     const CaseStudyurl35 = creat_url('Company Valuation for a Middle East Based Real Estate Investment & Development Firm');
     const CaseStudyurl36 = creat_url('Financial Due Diligence for a GP-led secondaries sale');
     const CaseStudyurl37 = creat_url('Brand Landscaping for a Destination Development Client');
     const CaseStudyurl38 = creat_url('Quarterly reporting framework for a US private equity');
     const CaseStudyurl39 = creat_url('Financial Model & Deal Analysis for a Regional Investment Leader in Real Estate');
     const CaseStudyurl40 = creat_url('Preliminary Deal Assessment for a private equity firm focused on multi-family real estate');
     const CaseStudyurl41 = creat_url('Thematic Research & Acquisition Mapping for a family office with diversified investments');
     const CaseStudyurl42 = creat_url('Subsequent Closing Deck for a multi-strategy private equity fund');
     const CaseStudyurl43 = creat_url('Standard Operating Procedures Finance & Accounting SOP Framework for an ultra-luxury hospitality group');
     const CaseStudyurl44 = creat_url('Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm');
     const CaseStudyurl45 = creat_url('Enterprise Risk Management Comprehensive ERM framework for a family office');
     const CaseStudyurl46 = creat_url('Business Requirements Document (BRD) Development');
     const CaseStudyurl47 = creat_url('Annual performance reporting framework');  
     const CaseStudyurl48 = creat_url('Due Diligence & Commercial Evaluation');     
     const CaseStudyurl49 = creat_url('Business Due Diligence');
     const CaseStudyurl50 = creat_url('Preliminary Due Diligence & Deal Model');


    const casestudies = [
        { 
            id: 1,
            heading: 'Expediting the Investment Process Through a Structured Roadmap', 
            paragraph: 'The client is a U.S.based private equity firm with investments in primarily three asset classes - credit, real assets and listed equities', 
            img: img1,
            link:`/${CaseStudyurl1}`
        },
        { 
            id: 2,
            heading: 'Enabling a U.S.based hedge fund to optimize its investment strategy', 
            paragraph: 'A U.S.based Hedge Fund with over $2 billion in assets under management and a focus on generating Alpha over and above market returns', 
            img: img2,
            link:`/${CaseStudyurl2}`
        },
        { 
            id: 3,
            heading: 'Streamlining business and facilitating the implementation of an ERP system', 
            paragraph: 'A leading real estate developer in the Middle East, specializing in developing high-end, experiential real estate projects across Kingdom of Saudi Arabia and UAE', 
            img: img3,
            link:`/${CaseStudyurl3}`
        },
        { 
          id: 4,
          heading: 'Enabling A Real Estate Conglomerate To Secure $40 million Funding to Develop A Logistics Park', 
          paragraph: 'A leading real estate master developer specializing in high-end experiential mixed-use real estate and mega-infra projects.', 
          img: img4,
          link:`/${CaseStudyurl4}`
        },
        { 
          id: 5,
          heading: 'Strategic Investment Blueprint For A Global Pharma Player', 
          paragraph: 'The client operates as a licensed Biopharmaceutical manufacturing and marketing firm. They are committed to leading patient-centric care by addressing significant gaps in the biopharma products landscape.', 
          img: img5,
          link:`/${CaseStudyurl5}`
        },
        { 
          id: 6,
          heading: 'Cultivating Employee Engagement Insights & Interventions for a Leading Conglomerate', 
          paragraph: 'The client operates as a diversified conglomerate with strong business footholds in sectors like construction, power, oil and gas, real estate, shipping, aviation, and logistics. Given its broad operations, the conglomerate naturally experiences varied employee sentiments across its diverse business units.', 
          img: img6,
          link:`/${CaseStudyurl6}`
        },
        { 
          id: 7,
          heading: 'Corporate Strategy For a Real Estate Development Company', 
          paragraph: 'The client is a real estate development company, established in 2021 and owned by a renowned sovereign wealth fund. They operate across a spectrum of segments including Residential, Commercial, Hospitality, Retail, Warehouse, Parking, Social Infrastructure, and more.', 
          img: img7,
          link:`/${CaseStudyurl7}`
        },
        { 
          id: 8,
          heading: 'Strategic Consulting For A PropTech Real Estate Equity Crowdfunding Platform In Kingdom of Saudi Arabia', 
          paragraph: 'The client, a PropTech startup in the Kingdom of Saudi Arabia, specializes in real estate equity crowdfunding. Their platform is designed to democratize access to real estate investment, allowing individuals to invest in vetted, high-quality projects at a smaller ticket size, while also aiding real estate companies in crowdfunding their projects. About the client:', 
          img: img8,
          link:`/${CaseStudyurl8}`
        },
        { 
          id: 9,
          heading: 'Industry Research for an HNI Launching a New Coffee Roastery Brand in the U.S.', 
          paragraph: 'The client is an American HNI (High Net-worth Individual) with significant investment holdings in the consumer discretionary and allied sectors.', 
          img: img9,
          link:`/${CaseStudyurl9}`
        },
        { 
          id: 10,
          heading: 'Vendor & Counter Party Due Diligence For A Government-Backed Kingdom of Saudi Arabia Entity', 
          paragraph: 'The client operates as a government-backed entity in the Kingdom of Saudi Arabia, with a mission to boost tourism in the region, generate employment opportunities, and help diversify the government’s sources of income.', 
          img: img10,
          link:`/${CaseStudyurl10}`
        },
        { 
          id: 11,
          heading: 'Private Equity Valuation Model For An Investment Firm', 
          paragraph: 'The client is an investment firm seeking to expand its investment portfolio across real estate and non-real estate asset classes, including both private and public equity markets.', 
          img: img11,
          link:`/${CaseStudyurl11}`
        },
        { 
          id: 12,
          heading: 'Investment Policy Statement For An Endowment Fund', 
          paragraph: 'The client is an endowment fund established 15 years ago with the aim of preserving, enhancing, and transferring wealth to upcoming generations. The fund manages an AUM of $35 million invested in a diversified portfolio of traditional and alternative asset classes.', 
          img: img12,
          link:`/${CaseStudyurl12}`
        },
        { 
          id: 13,
          heading: 'Equity Valuation & Fairness Opinion Exercise For A U.S.Based Hedge Fund', 
          paragraph: 'The client is a U.S.based hedge fund with $250 million in AUM. The fund leverages a long-short investment strategy to generate alpha, or excess returns, that outperform the broader market.',
          img: img13,
          link:`/${CaseStudyurl13}`
        },
        { 
          id: 14,
          heading: 'Human Resource Reporting Dashboard For A Company In The Hospitality Industry', 
          paragraph: 'The client is a closed joint stock company in the hospitality sector owned by a Sovereign Wealth Fund. They specialize in creating unique travel experiences through eco-tourism, agri-tourism, and adventure tourism.',
          img: img14,
          link:`/${CaseStudyurl14}`
        },
        { 
          id: 15,
          heading: 'Funding Strategy For A Real Estate Development Subsidiary', 
          paragraph: 'The client is a wholly-owned real estate development subsidiary of a Sovereign Wealth Fund, tasked with restoring a UN-recognized historically significant district.',
          img: img15,
          link:`/${CaseStudyurl15}`
        },
        { 
          id: 16,
          heading: 'Enterprise Project Management Office For A Real Estate Development Company', 
          paragraph: 'The client is a subsidiary of a sovereign wealth fund that functions as a real estate development company. With a mandate totaling approximately $20 billion, the company operates across diverse segments within the real estate sector.',
          img: img16,
          link:`/${CaseStudyurl16}`
        },
        { 
          id: 17,
          heading: 'Consolidated Financial Model  for a Kingdom of Saudi Arabia-Based Real Estate Development Project', 
          paragraph: 'The client is a Kingdom of Saudi Arabia-based real estate developer focused on preservation and redevelopment projects to revitalize a historically significant region comprising approximately 1,400 assets.',
          img: img17,
          link:`/${CaseStudyurl17}`
        },
        { 
          id: 18,
          heading: 'Investment Memorandum for an Investment Firm', 
          paragraph: 'The client is a state-owned investment firm, managing a portfolio exceeding %2.5 billion. This portfolio includes an array of real estate investments throughout the Southeast Asia region.',
          img: img18,
          link:`/${CaseStudyurl18}`
        },
        { 
          id: 19,
          heading: 'Optimizing Business Processes For A Real Estate Developer', 
          paragraph: 'The client is a leading real estate developer in the Middle East specializing in developing high-end experiential real estate projects across Kingdom of Saudi Arabia and the United Arab Emirates.',
          img: img19,
          link:`/${CaseStudyurl19}`
        },
        { 
          id: 20,
          heading: 'Financial Due Diligence For A U.S.Based Private Equity Firm', 
          paragraph: 'The client is a U.S.based private equity firm specializing in small-ticket investments ranging from $10 to $20 million. They primarily invest in companies with strong growth potential and competitive market positioning.',
          img: img20,
          link:`/${CaseStudyurl20}`
        },
        { 
          id: 21,
          heading: 'Corporate Strategy For A Single-Family Office', 
          paragraph: 'The client is a family office governing and managing a multi-asset class portfolio worth $15 billion.',
          img: img21,
          link:`/${CaseStudyurl21}`
        },
        { 
          id: 22,
          heading: 'Customized BI Dashboards for an Investment Corporate', 
          paragraph: 'The client is an investment corporate managing an AUM of $750 million, specializing in diverse asset classes including public and private equity, fixed income products, etc.',
          img: img22,
          link:`/${CaseStudyurl22}`
        },
        { 
          id: 23,
          heading: 'Periodic Portfolio Performance Review For a U.S.based PE firm', 
          paragraph: 'A U.S.based PE firm specializes in mid-market transactions within the Industrial Products, Utilities, and Infrastructure space. Its strategy focuses on leveraging expertise to transform companies into market leaders',
          img: img23,
          link:`/${CaseStudyurl23}`
        },
        { 
          id: 24,
          heading: 'Enabling Sector Understanding Through WACC Benchmarking', 
          paragraph: 'A London-based boutique private equity firm specializing in investments and deal structuring in mid-scale utilities projects across Europe. Their portfolio spans renewable and non-renewable sectors, including power plant generation and distribution, gas transmission and distribution.',
          img: img24,
          link:`/${CaseStudyurl24}`
        },
        { 
          id: 25,
          heading: 'Tourism Industry Research For a company operating in the hospitality sector', 
          paragraph: 'A company operating in the hospitality sector, wholly-owned by a sovereign wealth fund focused primarily on Agriculture, Eco & Adventure tourism and other service activities',
          img: img25,
          link:`/${CaseStudyurl25}`
        },
        { 
          id: 26,
          heading: 'Feasibility Study For A Hotel Development By A Real Estate Development Company', 
          paragraph: 'A prominent real estate development company focused on building large-scale and mixed-use projects',
          img: img26,
          link:`/${CaseStudyurl26}`
        },
        { 
          id: 27,
          heading: 'Annual Operating Plan and Budget for a Single Family Office', 
          paragraph: 'A multi-billion-dollar single family-office established with an intent to own, preserve, invest and manage a diverse global real estate portfolio and private equity holdings',
          img: img27,
          link:`/${CaseStudyurl27}`
        },
        { 
          id: 28,
          heading: 'Comprehensive Business Plan and a go-to-market strategy for a fintech company', 
          paragraph: 'A FinTech Company, that enables investors to invest in Institutional Grade Real Estate properties through a Crowdfunding Platform',
          img: img28,
          link:`/${CaseStudyurl28}`
        },
        { 
          id: 29,
          heading: 'Optimizing the Development Stage-Gate Process for a Real Estate company', 
          paragraph: 'A renowned Real Estate Company providing Development Management Service (DMS) in Commercial & Hospitality segments',
          img: img29,
          link:`/${CaseStudyurl29}`
        },
        { 
          id: 30,
          heading: 'REIT Market research for a KSA-based real estate fund manager', 
          paragraph: 'The client is a real estate fund manager, offering services in dealing, investment fund management, and custody activities. They specialize in asset management and real estate funds',
          img: img30,
          link:`/${CaseStudyurl30}`
        },
        { 
          id: 31,
          heading: 'Public Equity Screening And Industry Benchmarking for a Saudi based family office', 
          paragraph: 'A family office that has grown into a diversified investment management firm with holdings across real estate, private equity, public equity, and private credit',
          img: img31,
          link:`/${CaseStudyurl31}`
        },
        { 
          id: 32,
          heading: 'Joint Venture Proposal for a Infrastructure-Focused Investment fund', 
          paragraph: 'A diversified infrastructure-focused investment fund with managing an AUM of ~USD 12 Bn',
          img: img32,
          link:`/${CaseStudyurl32}`
        },
        { 
          id: 33,
          heading: 'Facilitated IPO planning through comprehensive market analysis and advisor benchmarking', 
          paragraph: 'A leading investment group that operates a diversified portfolio of investments across various sectors, including real estate, healthcare, education, hospitality, and financial services',
          img: img33,
          link:`/${CaseStudyurl33}`
        },
        { 
          id: 34,
          heading: 'Master Developer Partnership Proposal for a Master Developer based out of KSA', 
          paragraph: 'A Master Developer offering development management services across real estate segment. The company\'s current portfolio includes 2 development funds and 2 investment funds of $400 Mn',
          img: img34,
          link:`/${CaseStudyurl34}`
        },
        { 
          id: 35,
          heading: 'Company Valuation for a Middle East Based Real Estate Investment & Development Firm', 
          paragraph: 'A leading real estate investment, development, and property management company in the Middle East, recognized for executing high-quality projects and consistently delivering strong returns to stakeholders',
          img: img35,
          link:`/${CaseStudyurl35}`
        },
        { 
          id: 36,
          heading: 'Financial Due Diligence for a GP-led secondaries sale', 
          paragraph: 'A growth-focused venture capital fund with an AUM of approximately USD 300 Mn, pursuing a private equity secondaries transaction to acquire stakes in portfolio companies of another VC fund',
          img: img36,
          link:`/${CaseStudyurl36}`
        },
        { 
          id: 37,
          heading: 'Brand Landscaping for a Destination Development Client', 
          paragraph: 'The client operates in destination development, specializing in creating culturally immersive and architecturally iconic landmarks. By integrating Eastern heritage, it delivers transformative real estate experiences',
          img: img37,
          link:`/${CaseStudyurl37}`
        },
        { 
          id: 38,
          heading: 'Quarterly reporting framework for a US private equity', 
          paragraph: 'A US-based mid-market private equity platform with an investment thesis focused on growth equity opportunities across specialized market segments',
          img: img38,
          link:`/${CaseStudyurl38}`
        },
        { 
          id: 39,
          heading: 'Financial Model & Deal Analysis for a Regional Investment Leader in Real Estate ', 
          paragraph: 'The client is a regional investment leader in real estate, enhancing urban value & community well-being through sustainable projects with specialist operators under flexible, performance-driven models',
          img: img39,
          link:`/${CaseStudyurl39}`
        },
        { 
          id: 40,
          heading: 'Preliminary Deal Assessment for a private equity firm focused on multi-family real estateQuarterly reporting framework for a US private equity', 
          paragraph: 'A mid-market size PE firm managing multi-family real estate assets, targeting properties with operational upside and stable income, with a portfolio of 14+ acquisitions and 10+ realized exits',
          img: img40,
          link:`/${CaseStudyurl40}`
        },
        { 
          id: 41,
          heading: 'Thematic Research & Acquisition Mapping for a family office with diversified investments', 
          paragraph: 'A prominent Family Office focusing on venture, growth and buyout investments across diverse sectors',
          img: img41,
          link:`/${CaseStudyurl41}`
        },
        { 
          id: 42,
          heading: 'Subsequent Closing Deck for a multi-strategy private equity fund', 
          paragraph: 'A multi-strategy mid-market private equity fund focused on investing in growing companies within fragmented industries',
          img: img42,
          link:`/${CaseStudyurl42}`
        },
        { 
          id: 43,
          heading: 'Standard Operating Procedures Finance & Accounting SOP Framework for an ultra-luxury hospitality group', 
          paragraph: 'A hospitality group, fully owned by a sovereign wealth fund, focused on transforming historic and cultural sites into ultra-luxury boutique hotels',
          img: img43,
          link:`/${CaseStudyurl43}`
        },
        { 
          id: 44,
          heading: 'Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm', 
          paragraph: 'A Software-as-a-Service (SaaS) focused operator of tech companies growing tech ecosystem by investing across high potential technology and software businesses',
          img: img44,
          link:`/${CaseStudyurl44}`
        },
        { 
          id: 45,
          heading: 'Enterprise Risk Management Comprehensive ERM framework for a family office', 
          paragraph: 'A family office managing a real estate portfolio,  aiming to enhance governance and establish a proactive framework for enterprise-wide risk identification and mitigation',
          img: img45,
          link:`/${CaseStudyurl45}`
        },
        { 
          id: 46,
          heading: 'Business Requirements Document (BRD) Development', 
          paragraph: 'A strategic holding company operating across the technology, real estate, and prop-tech sectors, with a focus on building and scaling high-value ventures',
          img: img46,
          link:`/${CaseStudyurl46}`
        },
        { 
          id: 47,
          heading: 'Annual performance reporting framework', 
          paragraph: 'A leading regional conglomerate with diversified interests across industrial & real estate, managing over USD 1Bn in assets, recognized for its commitment to operational excellence & sustainable growth',
          img: img47,
          link:`/${CaseStudyurl47}`
        },
        { 
          id: 48, 
          heading: 'Due Diligence & Commercial Evaluation: Proposed Sustainable Materials Joint Venture ', 
          paragraph: 'The client is a developer focused on transformational real estate. It develops sustainable, high-impact projects by partnering with specialist operators through flexible, performance-driven commercial models', 
          img: img48, link:`/${CaseStudyurl48}` 
        },
        { id: 49,
          heading: 'Business Due Diligence', 
          paragraph: 'The client is a PE firm focused on providing equity-funded capital to scale established businesses. It partners with experienced operators in fragmented industries to drive growth and long-term value creation', 
          img: img49, 
          link:`/${CaseStudyurl49}` 
        },
        { id: 50,
          heading: 'Preliminary Due Diligence & Deal Model', 
          paragraph: 'The client is a PE firm focused on consumer and business services, combining thematic investing with deep operational expertise to scale service businesses and deliver strong, sustainable returns for investors', 
          img: img50, 
          link:`/${CaseStudyurl50}` 
        }
      ]

      const scrollToTop = () => {
        setBlank(true);
        setTimeout(() => {
        window.scrollTo(0, 0);
        }, 100);
        setTimeout(() => {
        setBlank(false);            
        }, 600);
      }

        
    // function truncateString(string, maxLength) {
    //     const words = string.split(' ');
    //     const truncatedWords = words.slice(0, maxLength);
    //     return truncatedWords.join(' ');
    // }


    function truncateString(str, maxChars, maxWords) {
      // Character-based truncation
      if (str.length > maxChars) {
          let truncated = str.slice(0, maxChars);
          let lastSpaceIndex = truncated.lastIndexOf(" ");
          if (lastSpaceIndex !== -1) {
              truncated = truncated.slice(0, lastSpaceIndex); // Avoid cutting words
          }
          str = truncated;
      }
  
      // Word-based truncation
      let words = str.split(" ");
      if (words.length > maxWords) {
          str = words.slice(0, maxWords).join(" ");
      }
  
      return str;
  }
    
    return (
        <>
            <Container className='casestudy-section desktop'>
                <Row>
                    
                    
                    {/* <Col className='col-md-4 mt-4 mb-5 pb-4'>
                        <div className='p-2'>
                            <div>
                            <NavLink to="/casestudy1" onClick={scrollToTop}>
                                <img src={img1} alt='' />
                            </NavLink>
                            </div>
                            <div>
                            <NavLink to="/casestudy1" onClick={scrollToTop}>
                                  <h2 className='mt-4'>{heading}</h2>
                                <p className='mt-4'>{paragraph}</p>
                                <p className='anima'><span className='anima-underline' > **** </span></p>
                            </NavLink>
                            </div>
                            <button className='mt-4'>{bttn}</button>
                        </div>
                    </Col> */}

                    {

                    casestudies.reverse().map((d) => {
                       const short = truncateString(d.paragraph, 75 , 14);
                       const title = truncateString(d.heading,60, 10);
                      return (
                        <Col key={d.index} className='col-md-4 mt-4 mb-5 pb-4'>
                        <div className='p-2'>
                            <div>
                            <NavLink to={d.link} onClick={scrollToTop}>
                                <img src={d.img} alt='' />
                            </NavLink>
                            </div>
                            <div>
                            <NavLink to={d.link} onClick={scrollToTop}>
                                  <h2 className='mt-4'>{d.heading.length <= title.length  ? title : title+'..' }</h2>
                                <p className='mt-4'>{d.paragraph.length <= short.length  ? short : short+'..' }</p>
                                <p className='anima'><span className='anima-underline' > **** </span></p>
                            </NavLink>
                            </div>
                            <NavLink to={d.link} onClick={scrollToTop}>
                            <button className='mt-4'>Read more</button>
                            </NavLink>
                        </div>
                    </Col>
                

                        )
                      })
                  }

                    {/* <Col className='col-md-4 mt-4 mb-5 pb-4'>
                        <div className='p-2'>
                            <div>
                                <img src={img1} alt='' />
                            </div>
                            <div>
                                <h2 className='mt-4'>{heading}</h2>
                                <p className='mt-4'>{paragraph}</p>
                                <p className='anima'><span className='anima-underline' > **** </span></p>
                            </div>
                            <button className='mt-4'>{bttn}</button>
                        </div>
                    </Col>
                    <Col className='col-md-4 mt-4 mb-5 pb-4'>
                        <div className='p-2'>
                            <div>
                                <img src={img1} alt='' />
                            </div>
                            <div>
                                <h2 className='mt-4'>{heading}</h2>
                                <p className='mt-4'>{paragraph}</p>
                                <p className='anima'><span className='anima-underline' > **** </span></p>
                            </div>
                            <button className='mt-4'>{bttn}</button>
                        </div>
                    </Col>
                     */}
                </Row>
            </Container>



            {
                casestudies.map((d) => (
            
                    <Row key={d.index} className='m-0 mt-2 g-0 mobile'>
                    <Col className='col-md-6 mobile'>
                    <NavLink to={d.link} onClick={scrollToTop}>
                       <div className='sol-box white ser-box3' style={{ backgroundImage: `url(${d.img})` }}>
                        <div className='text-box'>
                          <p className='p-5 empty-para'>
                          </p>
                        </div>
  
                      </div>
                      </NavLink>
                    </Col>
                    <Col className='col-md-6 mobile'>
                      <div className='sol-box white d-bg-box '>
                        <div className='p-5 mobilepadding'>
                        <NavLink to={d.link} onClick={scrollToTop}>
                          <h4>{d.heading}</h4>
                          <p>{d.paragraph} </p>
                          <p className='anima'><span className='anima-underline' > **** </span></p>
                       </NavLink>
                          <div className='mob-align'>
                            <NavLink to={d.link} onClick={scrollToTop}>
                              <button className="findout-btn mt-3 ">Read more</button>
                            </NavLink>  </div>
                        </div>
                      </div>
                    </Col>
              </Row>
  
                    
                ))
            }         

            {/* <Row className='m-0 g-0 mobile'>
                  <Col className='col-md-6 mobile'>
                  <NavLink to="/casestudy1" onClick={scrollToTop}>
                     <div className='sol-box white ser-box3' style={{ backgroundImage: `url(${img1})` }}>
                      <div className='text-box'>
                        <p className='p-5 empty-para'>
                        </p>
                      </div>

                    </div>
                    </NavLink>
                  </Col>
                  <Col className='col-md-6 mobile'>
                    <div className='sol-box white d-bg-box '>
                      <div className='p-5 mobilepadding'>
                      <NavLink to="/casestudy1" onClick={scrollToTop}>
                        <h4>{heading}</h4>
                        <p>{paragraph} </p>
                        <p className='anima'><span className='anima-underline' > **** </span></p>
                     </NavLink>
                        <div className='mob-align'>
                          <NavLink to="/about" onClick={scrollToTop}>
                            <button className="findout-btn mt-3 ">Find out more about us</button>
                          </NavLink>  </div>
                      </div>
                    </div>
                  </Col>
            </Row> */}

        </>
    )
}

export default CaseStudies